export default {
  computed: {
    rules() {
      return { required: [(v) => !!v || 'Это поле обязательно'] }
    },
    messages() {
      return {
        needFillAllRequiredFields: 'Необходимо заполнить все обязательные поля',
        successUpdated: 'Обновлено',
        successCreated: 'Добавлено',
        successSaved: 'Сохранено',
        successDeleted: 'Удалено',
      }
    },
  },
}
